import React, { useContext } from 'react'
import { func, string } from 'prop-types'
import { useTranslation } from 'react-i18next'
import Icon from 'components/uiElements/Icon'
import Tooltip from 'components/Tooltip'
import BackNavigationHeader from 'components/designSidepanel/BackNavigationHeader'
import { productDataType } from 'models/propTypes'
import RelatedProductsContainer from 'containers/designSidepanel/RelatedProductsContainer'
import FavoriteButtonContainer from 'containers/uiElements/FavoriteButtonContainer'
import SugarcubeContext from 'apps/SugarcubeContext'
import { TRACK_LOCATION_SIDEPANEL } from 'models/tracking/constants'
import AdminProductDetailsContainer from 'containers/admin/AdminProductDetailsContainer'
import ImagePicker from './ImagePicker'
import ProductSummary from './ProductSummary'

require('./ProductDetailsView.scss')

const ProductDetailsView = ({ furnitureData, addToRoom, addToBag, trackShowDetails, onBackClick, navigationText }) => {
    const { t } = useTranslation()

    const { name, localItemNumber, thumbUrl, imageUrls } = furnitureData

    const { isMagicWindow, isKiosk } = useContext(SugarcubeContext)

    return (
        <div className="ProductDetailsView">
            <BackNavigationHeader onClick={onBackClick} navigationText={navigationText} />
            <div className="content">
                <div className="contentInner">
                    <div className="itemSummary">
                        <div className="thumbContainer">
                            <ImagePicker images={imageUrls} thumbUrl={thumbUrl} name={name} />
                        </div>
                        <div className="itemDetails">
                            <ProductSummary productData={furnitureData} trackShowDetails={trackShowDetails} />
                            <AdminProductDetailsContainer productData={furnitureData} />
                        </div>
                    </div>
                    {!isMagicWindow && <RelatedProductsContainer />}
                </div>
                <div className="ctaSection">
                    <div className="addToRoom" onClick={addToRoom}>
                        <button>{t('design.add to your room')}</button>
                    </div>
                    <div className="secondaryCTAs">
                        {localItemNumber && !isKiosk && (
                            <>
                                <Tooltip />
                                <button onClick={addToBag} data-tip={t('tooltip.add to shopping bag')}>
                                    <Icon svg code="shopping_bag_add" />
                                </button>
                                <FavoriteButtonContainer
                                    localItemNumber={localItemNumber}
                                    location={TRACK_LOCATION_SIDEPANEL}
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

ProductDetailsView.propTypes = {
    furnitureData: productDataType.isRequired,
    addToRoom: func.isRequired,
    addToBag: func.isRequired,
    trackShowDetails: func.isRequired,
    onBackClick: func.isRequired,
    navigationText: string.isRequired,
}

export default ProductDetailsView
